import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HomeBackground from '../../assets/images/HomeBackground.jpg';
import HomeTeam from '../../assets/images/HomeTeam.jpg';
import HomeFabricProducts from '../../assets/images/HomeFabricProducts.png';
import HomeBanner from '../../assets/images/HomeBanner.jpg';

import CertSGS from '../../assets/images/CertSGS.jpg';
import CertRoHS from '../../assets/images/CertRoHS.jpg';
import CertIAF from '../../assets/images/CertIAF.jpg';
import CertCNAS from '../../assets/images/CertCNAS.jpg';
import CertISO9001 from '../../assets/images/CertISO9001.jpg';
import CertOEKO from '../../assets/images/CertOEKO.jpg';
import CertSTAND from '../../assets/images/CertSTAND.jpg';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative min-h-screen flex items-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${HomeBackground})`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Delivering <strong>Durable, Eco-Friendly</strong>, and High-Performance Non-Woven Materials to Industries Worldwide
            </h1>
            <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
              With <strong>20 years of expertise</strong> in non-woven technology, Taishun Global supplies innovative, 
              sustainable, and cost-effective non-woven materials that meet the highest global standards.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/applications"
                className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                Explore Solutions
              </Link>
              <Link
                to="/contact"
                className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-900 px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                Request a Quote
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                About Taishun Global
              </h2>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                Headquartered in Asia and serving clients across the globe, <strong>Taishun Global specializes in designing and manufacturing premium non-woven fabrics</strong>. 
                From design to delivery, we combine cutting-edge technology with eco-friendly production to ensure 
                durability, performance, and environmental responsibility.
              </p>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-leaf-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Sustainable Materials</h4>
                    <p className="text-gray-600 text-sm">Eco-friendly production processes</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-factory-line text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">20 Years Expertise</h4>
                    <p className="text-gray-600 text-sm">Professional manufacturing experience</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-global-line text-purple-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Global Logistics</h4>
                    <p className="text-gray-600 text-sm">Reliable worldwide delivery</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-settings-line text-orange-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Custom Solutions</h4>
                    <p className="text-gray-600 text-sm">Tailored for diverse industries</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="grid grid-cols-1 gap-4">
              <div className="relative">
                <img
                  src={HomeTeam}
                  alt="Taishun Global manufacturing facility and team"
                  className="rounded-lg shadow-lg object-cover w-full h-64"
                />
              </div>
              <div className="relative">
                <img
                  src={HomeFabricProducts}
                  alt="Taishun Global non-woven fabric products"
                  className="rounded-lg shadow-lg object-cover w-full h-64"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Certifications */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Quality Certifications
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our commitment to excellence is validated by <strong>internationally recognized certifications</strong>, 
              ensuring the highest standards in quality, safety, and environmental responsibility.
            </p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-6">
            <div className="bg-gray-50 rounded-lg p-4 hover:shadow-lg transition-shadow duration-200 flex flex-col items-center">
              <img
                src={CertSGS}
                alt="SGS Certification"
                className="w-20 h-20 object-contain mb-3"
              />
              <h4 className="text-sm font-semibold text-gray-900 text-center">SGS</h4>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-4 hover:shadow-lg transition-shadow duration-200 flex flex-col items-center">
              <img
                src={CertRoHS}
                alt="RoHS Certification"
                className="w-20 h-20 object-contain mb-3"
              />
              <h4 className="text-sm font-semibold text-gray-900 text-center">RoHS</h4>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-4 hover:shadow-lg transition-shadow duration-200 flex flex-col items-center">
              <img
                src={CertIAF}
                alt="IAF Certification"
                className="w-20 h-20 object-contain mb-3"
              />
              <h4 className="text-sm font-semibold text-gray-900 text-center">IAF</h4>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-4 hover:shadow-lg transition-shadow duration-200 flex flex-col items-center">
              <img
                src={CertCNAS}
                alt="CNAS Certification"
                className="w-20 h-20 object-contain mb-3"
              />
              <h4 className="text-sm font-semibold text-gray-900 text-center">CNAS</h4>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-4 hover:shadow-lg transition-shadow duration-200 flex flex-col items-center">
              <img
                src={CertISO9001}
                alt="ISO 9001 Certification"
                className="w-20 h-20 object-contain mb-3"
              />
              <h4 className="text-sm font-semibold text-gray-900 text-center">ISO 9001</h4>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-4 hover:shadow-lg transition-shadow duration-200 flex flex-col items-center">
              <img
                src={CertOEKO}
                alt="OEKO-TEX Certification"
                className="w-20 h-20 object-contain mb-3"
              />
              <h4 className="text-sm font-semibold text-gray-900 text-center">OEKO-TEX</h4>
            </div>
            
            <div className="bg-gray-50 rounded-lg p-4 hover:shadow-lg transition-shadow duration-200 flex flex-col items-center">
              <img
                src={CertSTAND}
                alt="STANDARD 100 Certification"
                className="w-20 h-20 object-contain mb-3"
              />
              <h4 className="text-sm font-semibold text-gray-900 text-center">STANDARD 100</h4>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <div className="bg-teal-50 rounded-lg p-8 max-w-4xl mx-auto">
              <div className="flex items-center justify-center space-x-3 mb-4">
                <i className="ri-award-line text-teal-600 text-2xl"></i>
                <h3 className="text-xl font-bold text-gray-900">Certified Excellence</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                These certifications demonstrate our unwavering commitment to <strong>quality, safety, and environmental responsibility</strong>. 
                Every product we manufacture meets or exceeds international standards, giving you confidence in our materials.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Global Map Banner */}
      <section 
        className="py-20 bg-cover bg-center relative"
        style={{
          backgroundImage: `linear-gradient(rgba(14, 116, 144, 0.9), rgba(14, 116, 144, 0.9)), url(${HomeBanner})`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Supplying Non-Woven Solutions to Every Corner of the World
          </h2>
          <p className="text-xl text-gray-200 mb-8 max-w-3xl mx-auto">
            From Asia to Europe, Americas to Africa - our <strong>global network ensures reliable delivery</strong> 
            of premium non-woven materials to manufacturers and businesses worldwide.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-12">
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-2">10+</div>
              <div className="text-gray-200">Countries Served</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-2">1000+</div>
              <div className="text-gray-200">Global Clients</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-2">20</div>
              <div className="text-gray-200">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-2">24/7</div>
              <div className="text-gray-200">Customer Support</div>
            </div>
          </div>
        </div>
      </section>

      {/* Industries We Serve */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Industries We Serve
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our <strong>versatile non-woven materials</strong> power innovation across multiple industries, 
              delivering performance and sustainability where it matters most.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-sofa-line',
                title: 'Furniture & Home',
                description: 'Upholstery backing, mattress covers, cushion support layers',
                color: 'bg-blue-100 text-blue-600'
              },
              {
                icon: 'ri-car-line',
                title: 'Automotive',
                description: 'Headliners, trunk liners, interior insulation, seat padding',
                color: 'bg-green-100 text-green-600'
              },
              {
                icon: 'ri-building-line',
                title: 'Construction',
                description: 'Geotextiles, roofing membranes, insulation layers',
                color: 'bg-orange-100 text-orange-600'
              },
              {
                icon: 'ri-plant-line',
                title: 'Agriculture',
                description: 'Crop covers, weed control fabrics, plant protection',
                color: 'bg-green-100 text-green-600'
              },
              {
                icon: 'ri-shopping-bag-line',
                title: 'Packaging',
                description: 'Reusable bags, protective wrapping, eco-friendly solutions',
                color: 'bg-purple-100 text-purple-600'
              },
              {
                icon: 'ri-heart-pulse-line',
                title: 'Healthcare',
                description: 'Surgical gowns, masks, filtration layers, medical supplies',
                color: 'bg-red-100 text-red-600'
              }
            ].map((industry, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6 hover:shadow-lg transition-shadow duration-200">
                <div className={`w-12 h-12 ${industry.color} rounded-lg flex items-center justify-center mb-4`}>
                  <i className={`${industry.icon} text-xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{industry.title}</h3>
                <p className="text-gray-600">{industry.description}</p>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <Link
              to="/applications"
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Explore All Applications
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-teal-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Transform Your Manufacturing?
          </h2>
          <p className="text-xl text-teal-100 mb-8 max-w-3xl mx-auto">
            Join thousands of manufacturers worldwide who trust Taishun Global for their 
            <strong> non-woven material needs</strong>. Get started with a custom quote today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-white text-teal-600 hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Get Custom Quote
            </Link>
            <Link
              to="/product-characteristics"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-3 rounded-lg font-semibold transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              View Product Features
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
